export default __webpack_public_path__ + "static/BC_BOWL-8705f9b13084e64c65f221668447df69.png";